import React from 'react'
import {
  HStack,
  FormControl,
  FormLabel,
  Select,
  Button,
  Box,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { ContentTagOptions } from '@/hooks/useContentTagSuggestions'

interface ContentOptionsPanelProps {
  options: ContentTagOptions
  onOptionsChange: (field: keyof ContentTagOptions, value: any) => void
  onAnalyze: () => void
  isLoading?: boolean
}

export function ContentOptionsPanel({
  options,
  onOptionsChange,
  onAnalyze,
  isLoading,
}: ContentOptionsPanelProps) {
  const { t } = useTranslation('files')
  return (
    <Box
      bg="white"
      p={4}
      borderRadius="lg"
      border="1px solid"
      borderColor="gray.200"
      boxShadow="sm"
    >
      <HStack spacing={6} align="end">
        <FormControl maxW="180px">
          <FormLabel fontSize="sm" fontWeight="semibold" color="gray.700" mb={2}>
            {t('contentOptionsPanel.maximumTags')}
          </FormLabel>
          <NumberInput
            size="md"
            value={options.max_tags}
            min={5}
            max={20}
            step={5}
            onChange={(_, valueAsNumber) => onOptionsChange('max_tags', valueAsNumber || 5)}
          >
            <NumberInputField
              borderColor="gray.300"
              _hover={{ borderColor: 'gray.400' }}
              _focus={{ borderColor: 'blue.500', boxShadow: '0 0 0 1px blue.500' }}
            />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </FormControl>

        <Button
          size="md"
          colorScheme="blue"
          onClick={onAnalyze}
          isLoading={isLoading}
          loadingText={t('contentOptionsPanel.analyzing')}
          borderRadius="lg"
          px={6}
          fontWeight="semibold"
          _hover={{
            transform: 'translateY(-1px)',
            boxShadow: 'lg',
          }}
          transition="all 0.2s"
        >
          {t('contentOptionsPanel.analyzeContent')}
        </Button>
      </HStack>
    </Box>
  )
}
